import $ from "jquery";
import {getCookie} from "../common/utils/getCookie";

export const verificationTokenKey = "__RequestVerificationToken";
const verificationFallbackFormToken = "__RV_FormToken";
const verificationFormToken = "epreqverformtoken";

export class RequestAntiForgeryHelper {
    static getAntiForgeryToken() {
        let result = getCookie(verificationFormToken) ||
                     getCookie(verificationFallbackFormToken) ||
                     "";
        return result;
    }

    static getAntiForgeryField() {
        return $("<input>").attr({
            type: "hidden",
            name: verificationTokenKey,
            value: this.getAntiForgeryToken(),
        });
    }

    /**
     * 
     * @param {JQuery.AjaxSettings} requestOptions
     */
    static setAntiForgeryToken(requestOptions) {
        if (requestOptions.type.toLowerCase() === "post") {
            requestOptions.headers = requestOptions.headers || {};
            requestOptions.headers[verificationTokenKey] = RequestAntiForgeryHelper.getAntiForgeryToken();
        }
    }
}
